// extracted by mini-css-extract-plugin
module.exports = {"overlayContainer":"loading_overlayContainer__3-FJP","fullPageContainer":"loading_fullPageContainer__3l3ZC"};